/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Input_PlaceholderInputs */

const en_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your message...`)
};

const es_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe tu mensaje...`)
};

const fr_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez votre message...`)
};

const de_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibe deine Nachricht...`)
};

const ja_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを入力...`)
};

const zh_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的消息...`)
};

const ar_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتب رسالتك...`)
};

const id_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketik pesan Anda...`)
};

const it_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi il tuo messaggio...`)
};

const ru_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите сообщение...`)
};

const pt_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite sua mensagem...`)
};

const ko_inbox_input_placeholder = /** @type {(inputs: Inbox_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지를 입력하세요...`)
};

/**
* | output |
* | --- |
* | "Type your message..." |
*
* @param {Inbox_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_input_placeholder = /** @type {((inputs?: Inbox_Input_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Input_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_input_placeholder(inputs)
	if (locale === "es") return es_inbox_input_placeholder(inputs)
	if (locale === "fr") return fr_inbox_input_placeholder(inputs)
	if (locale === "de") return de_inbox_input_placeholder(inputs)
	if (locale === "ja") return ja_inbox_input_placeholder(inputs)
	if (locale === "zh") return zh_inbox_input_placeholder(inputs)
	if (locale === "ar") return ar_inbox_input_placeholder(inputs)
	if (locale === "id") return id_inbox_input_placeholder(inputs)
	if (locale === "it") return it_inbox_input_placeholder(inputs)
	if (locale === "ru") return ru_inbox_input_placeholder(inputs)
	if (locale === "pt") return pt_inbox_input_placeholder(inputs)
	return ko_inbox_input_placeholder(inputs)
});